import type { ComponentProps } from 'react'
import { Hospital } from 'lucide-react'
import type { WebModule } from '../core/index.js'
import { AdminFacilityList } from './admin/AdminFacilityList.js'
import { FACILITIES_HELP_TOPICS } from './help.js'

/** What the facilities module contributes to the shells: the admin's directory of every facility, and the Scheduling tab's help. */
export const facilitiesWebModule: WebModule<ComponentProps<typeof AdminFacilityList>['api']> = {
  name: 'facilities',
  adminPages: [{ path: '/admin/facilities', label: 'Facilities', title: 'All Facilities', icon: Hospital, group: 'directory', page: ({ api }) => <AdminFacilityList api={api} /> }],
  helpTopics: FACILITIES_HELP_TOPICS,
}
